import { API_CONTENT_GET } from '../../../Constants/apiUrls';
import {
    FETCH_CONTENT_REQUEST,
    FETCH_CONTENT_SUCCESS,
    FETCH_CONTENT_FAILURE,
} from '../../../Constants/actionTypes';

import { API_GET_CONTENT_STORE } from '../../../Constants/apiUrls'
import { fetchAllContentHub } from '../../../Constants/apiService'




export const fetchContent = () => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCH_CONTENT_REQUEST });
        const state = getState();
        const token = state.auth.accessToken;
        try {
            const data = await fetchAllContentHub(token);
            dispatch({ type: FETCH_CONTENT_SUCCESS, payload: data });
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch({ type: FETCH_CONTENT_FAILURE, error: errorMessage });
        }
    };
};